import { Wizard } from '@/layouts'

import { requiresAuthNoAlert } from '@/lib/auth'
import store from '@/store'

export const requiresUser = (to, _from, next) => {
  const progress = store.getters['wizard/progress']

  let { claim_token } = to.params

  if (progress === null) {
    next({ name: `wizard`, params: { claim_token }})
  } else { 
    next()
  }
}

export default [
  {
    path: '/wizard/:claim_token',
    component: Wizard,
    children: [
      {
        name: 'wizard',
        path: '',
        props: true,
        component: () => import('@/views/Wizard/StepA'),
      },
      {
        name: 'wizardB',
        path: 'stepB',
        beforeEnter: requiresUser,
        component: () => import('@/views/Wizard/StepB'),
      },
      {
        name: 'wizardC',
        path: 'stepC',
        beforeEnter: requiresUser,
        component: () => import('@/views/Wizard/StepC'),
      },
      {
        name: 'wizardD',
        path: 'stepD',
        beforeEnter: requiresUser,
        component: () => import('@/views/Wizard/StepD'),
      },
      {
        name: 'wizardE',
        path: 'stepE',
        beforeEnter: requiresUser,
        component: () => import('@/views/Wizard/StepE'),
      },
      {
        name: 'wizardF',
        path: 'stepF',
        props: true,
        beforeEnter: requiresUser,
        component: () => import('@/views/Wizard/StepF'),
      },
    ],
  },
  {
    name: 'wizard/confirm',
    path: '/next-steps',
    component: () => import('@/views/Wizard/Confirmation'),
    beforeEnter: requiresAuthNoAlert,
  },
]